import styled from 'styled-components';

import { gridSizes, media } from 'utils/style';
import VehicleExtras from 'components/form/VehicleExtras/container';

export default styled(VehicleExtras)`
  h3 {
    line-height: 28px;
  }
  .extrasWrap {
    display: flex;
    margin-bottom: ${gridSizes('M')};
    ${media.lessThan('extraSmall')`
      flex-direction: column;
    `}
  }

  .title-tooltip {
    margin-left: 0.8rem;
  }

  .radios-container {
    margin: 1.6rem 0;
    fieldset {
      display: flex;
    }
  }

  .extra {
    display: flex;
    margin: ${gridSizes('M')} ${gridSizes('M')} 0 0;
    ${media.lessThan('small')`
      margin: 15px 18px 0 0;
    `}
  }

  label {
    margin: 0 ${gridSizes('S')} 0 0;
  }
  .tooltip {
    align-self: center;
  }

  ${media.lessThan('small')`
    padding-left: ${gridSizes('S')};

    .spacer {
      height: 56px;
    }
  `}
`;
